var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "JadeFloating",
    _vm._b(
      {
        attrs: {
          open: _vm.open,
          closeOn: _vm.closeOn,
          zIndex: _vm.zIndex,
          allowOutsideClick: false,
          dimmable: "",
        },
        on: { toggle: () => _vm.$emit("toggle") },
      },
      "JadeFloating",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "div",
        {
          class: _vm.computedClassModal,
          staticStyle: {
            opacity: "1",
            "transition-property": "opacity",
            "transition-duration": "250ms",
          },
          attrs: { tabindex: "-1" },
        },
        [
          !_vm.hideCloseButton
            ? _c(
                "div",
                { staticClass: "jade-modal__close" },
                [
                  _c("JadeIconButton", {
                    attrs: {
                      icon: "close",
                      variant: "neutral-ghost",
                      size: "medium",
                    },
                    on: { click: () => _vm.$emit("onClose") },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.title
            ? _c(
                "div",
                { staticClass: "jade-modal__header" },
                [
                  _c(
                    "JadeText",
                    {
                      attrs: {
                        variant: "heading-xsmall",
                        color: "current-color",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "jade-modal__main" },
            [
              _vm.$slots.cover
                ? _c(
                    "JadeAspectRatio",
                    { attrs: { as: "div", aspectRatio: "wide" } },
                    [_vm._t("cover")],
                    2
                  )
                : _vm._e(),
              _vm.$slots.default
                ? _c(
                    "div",
                    { class: _vm.computedClassContent },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.$slots.actionsGroup || _vm.$slots.actions
            ? _c(
                "div",
                { staticClass: "jade-modal__footer" },
                [
                  _vm.$slots.actionsGroup
                    ? _c(
                        "div",
                        { class: _vm.computedClassActionsGroup },
                        [_vm._t("actionsGroup")],
                        2
                      )
                    : _vm._e(),
                  _vm.$slots.actions
                    ? [
                        _c(
                          "div",
                          { staticClass: "jade-modal__footer-actions-mobile" },
                          [_vm._t("actions")],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "jade-modal__footer-actions-desktop" },
                          [_vm._t("actions")],
                          2
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }